<template>
  <div class="app-container">
    <el-card v-if="form">
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="title-box"><span class="txt1">治疗师</span></div>
      <el-descriptions>
        <el-descriptions-item label="姓名">{{form.customerName}}</el-descriptions-item>
        <el-descriptions-item label="身份">{{form.customerLevel}}</el-descriptions-item>
        <el-descriptions-item label="手机号码">{{form.customerPho}}</el-descriptions-item>
        <el-descriptions-item label="发布时间">{{form.createdTime}}</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">活动营销内容</span></div>
      <div class="treatment-box">
        <div class="tdesc">标题：{{form.storeName}}</div>
        <div class="tdesc">内容：{{form.storeIntro}}</div>
        <div class="tdesc">图片：</div>
        <div v-if="form.storeUrl">
          <el-image class="banner-box" v-for="(item,index) in form.storeUrl && form.storeUrl.split(',')" :key="index" :src="item" :preview-src-list="[item]"></el-image>
        </div>
      </div>
      <div class="title-box"><span class="txt1">数据分析</span></div>
      <el-descriptions>
        <el-descriptions-item label="发送C端用户人数">{{form.sendAppNum}}</el-descriptions-item>
        <el-descriptions-item label="查看人数">{{form.lookNum}}</el-descriptions-item>
        <el-descriptions-item label="浏览次数">{{form.browseNum}}</el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import userStoreApi from '@/api/archives/userStore'
export default {
  props: ['rowItem',],
  data() {
    return {
      form: {},
    }
  },
  created() {
    this.getDeatils()
  },
  methods: {
    getDeatils() {
      userStoreApi.fetchById(this.rowItem.id).then(res => {
        let data = res.data;
        this.form = data
      })
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
  }

}
</script>

<style lang="scss" scoped>
.banner-box {
  width: 50px;
  height: 50px;
  margin: 2px;
}
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.oppr-btn {
  text-align: right;
  margin-bottom: 20px;
}
.treatment-box {
  background-color: #eeeded;
  padding: 16px 28px;
  margin-bottom: 14px;
  .tdesc {
    font-size: 14px;
    color: #606266;
    padding-bottom: 12px;
    &.w2 {
      width: 49%;
      display: inline-block;
    }
  }
  .record-item {
    font-size: 14px;
    color: #606266;
    padding: 12px 8px;
    background: #fff;
    margin-bottom: 5px;
    width: 480px;
    span {
      color: #4680e3;
      cursor: pointer;
      float: right;
    }
  }
}
</style>
